<template>
  <div class="pg-layout-header">
    <slot name="baner"></slot>
    <i
      class="ivu-icon-icon-pg-lbst pg-layout-header__lbst"
      :class="{ 'pg-layout-header__lbst--retract': shrink }"
      @click="onShrink"
    ></i>
    <div class="pg-layout-header__center">
      <img
        class="pg-layout-header__center-organization-icon"
        v-if="userState?.organization?.logo"
        :src="userState?.organization?.logo"
      />
      <div class="pg-layout-header__center-organization" v-if="showOrganization">
        <span class="pg-layout-header__center-organization-name">
          {{ userState?.organization?.fullName || userState?.organization?.name }}
          <Tag type="warning" v-if="userState?.version?.forShort && showVersion">{{
            userState.version.forShort
          }}</Tag>
        </span>
        <span class="pg-layout-header__center-organization-date" v-if="showOrganizationDate">
          {{ systemOpenInfoDate }}
          <Tag
            type="warning"
            v-if="expire?.type === 'date' && (expire?.strict === 5 || expire?.strict === 3)"
            effect="dark"
            >{{ expire?.strict === 5 ? '即将到期' : '已到期' }}</Tag
          ></span
        >
      </div>
      <slot name="center"></slot>
    </div>
    <div class="pg-layout-header__right">
      <span class="pg-layout-header__right-date" v-if="curDate">今天是: {{ curDate }}</span>
      <template v-if="shortcutsList?.length > 0">
        <Dropdown class="pg-layout-header__right-other" trigger="hover" @command="handOther">
          <i class="pg-layout-header__right-other-down ivu-icon-icon-pg-i"></i>
          <template v-slot:dropdown>
            <DropdownMenu class="pg-layout-header__right-user-down-menu">
              <DropdownItem
                class="pg-layout-header__right-user-down-item"
                v-for="item in shortcutsList"
                :command="item.code"
                :key="item.code"
                >{{ item.name }}</DropdownItem
              >
            </DropdownMenu>
          </template>
        </Dropdown>
      </template>
      <slot></slot>
      <PgLayoutMessage v-if="messageShow"></PgLayoutMessage>
      <ColorPicker size="small" v-if="colorPickerShow" :value="color" @change="colorChange" />
      <Dropdown class="pg-layout-header__right-user" trigger="click" @command="handUser">
        <span class="pg-layout-header__right-user-down">
          <span>{{ userState?.currentToken?.user?.name }}</span
          ><i class="el-icon-caret-bottom el-icon--right"></i>
        </span>
        <template v-slot:dropdown>
          <DropdownMenu class="pg-layout-header__right-user-down-menu">
            <DropdownItem class="pg-layout-header__right-user-down-item" command="ownSpace"
              >个人中心</DropdownItem
            >
            <DropdownItem
              class="pg-layout-header__right-user-down-item"
              v-for="item in userOptions"
              :key="item.command"
              :command="item.command"
              divided
              >{{ item.text }}</DropdownItem
            >
            <!-- <DropdownItem class="pg-layout-header__right-user-down-item" command="help" divided
              >帮助中心</DropdownItem
            > -->
            <DropdownItem class="pg-layout-header__right-user-down-item" command="loginout" divided
              >退出登录</DropdownItem
            >
          </DropdownMenu>
        </template>
      </Dropdown>
      <Avatar
        class="pg-layout-header__right-avatar"
        size="small"
        :src="userState?.currentToken?.portrait"
      ></Avatar>
    </div>
  </div>
</template>
<script setup>
import { inject, computed, h, getCurrentInstance, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router/composables'
import { Avatar, Dropdown, DropdownMenu, DropdownItem, ColorPicker, Tag } from 'element-ui'
import { useTheme } from '../hook/use-theme'
import { USER_INJECTION_KEY } from '../../../tokens/index'
import { useHeaderUser } from '../hook/use-header-user'
import PgLayoutMessage from './layout-message.vue'
import DownloadApp from './download-app.vue'
import { pgMessageBox } from '../../message-box/index'
import { get } from '../../../utils/index'

const props = defineProps({
  shrink: {
    type: Boolean,
    default: false,
  },
  shortcuts: Array,
  defaultShortcutsShow: {
    type: Boolean,
    default: true,
  },
  messageShow: {
    type: Boolean,
    default: true,
  },
  colorPickerShow: {
    type: Boolean,
    default: true,
  },
  showOrganization: {
    type: Boolean,
    default: false,
  },
  showOrganizationDate: {
    type: Boolean,
    default: false,
  },
  showVersion: {
    type: Boolean,
    default: true,
  },
  currentDate: Boolean,
  //用户下拉菜单 [{command: '', text: ''}]
  userOptions: {
    type: Array,
    default: () => [],
  },
})
const emit = defineEmits(['on-shrink', 'on-shortcut', 'on-user'])
const { proxy } = getCurrentInstance()

const { color, colorChange } = useTheme(props.colorPickerShow)

const { userState } = inject(USER_INJECTION_KEY)
const systemOpenInfoDate = computed(() => {
  if (userState.systemOpenInfo && userState.systemOpenInfo.begin && userState.systemOpenInfo.end) {
    return `有效期：${userState.systemOpenInfo.begin.substr(
      0,
      10
    )} 至 ${userState.systemOpenInfo.end.substr(0, 10)}`
  } else {
    return ''
  }
})

const expire = computed(() => proxy.$store.state.menuStore.expire)

const onShrink = () => {
  emit('on-shrink')
}

//下拉的功能点
const appList = ref([])
const appNode = h(DownloadApp, { props: { appList: appList } })
const shortcutsList = computed(() =>
  props.defaultShortcutsShow
    ? [...(props.shortcuts ?? []), { code: 'version', name: '版本更新记录' }] //{ code: 'downloadApp', name: 'APP下载' }
    : [...(props.shortcuts ?? [])]
)
const router = useRouter()
const handOther = (command) => {
  if (command === 'version') {
    router.push({ name: 'version-update' })
  } else if (command === 'downloadApp') {
    get(
      proxy.GLOBAL.baseURL.includes('passport')
        ? 'rest/login/downloadItems'
        : 'rest/ezcomp/system/downloadItems'
    ).then(([resData]) => {
      if (!resData) return
      appList.value = resData?.data ?? []
      pgMessageBox({
        title: 'APP下载',
        message: appNode,
        showFooter: false,
        width: 'auto',
      })
    })
  } else {
    emit('on-shortcut', command)
  }
}

//用户操作
const { toPassport, toHelp, logout } = useHeaderUser()
const handUser = (command) => {
  if (command === 'ownSpace') {
    toPassport()
  } else if (command === 'loginout') {
    logout()
  } else if (command === 'help') {
    toHelp()
  } else {
    emit('on-user', command)
  }
}

//获取当前日期
const curDate = ref(null)
onMounted(async () => {
  if (props.currentDate) {
    const [res] = await get('rest/main/index/getCurrentDate')
    curDate.value = res?.data
  }
})
</script>
<style lang="scss">
@import '../style/layout-header.scss';
</style>
